export default {"src":"/_next/static/media/laptop.c053883e.svg","height":116,"width":336,"blurWidth":0,"blurHeight":0};